// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// SUB ENTRY POINT ENHANCEMENT SCHEMA
/////////////////////////////////////////

export const SubEntryPointEnhancementSchema = z.object({
  fullPath: z.string(),
  description: z.string(),
  graphId: z.string(),
  params: z.string().nullable(),
})

export type SubEntryPointEnhancement = z.infer<typeof SubEntryPointEnhancementSchema>

export default SubEntryPointEnhancementSchema;
